import {Box, Divider, List, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import ArrowDownIcon from '@icons/ArrowDownIcon';
import IChannel from './IChannel';
import MyChannel from './MyChannel';

interface IProps {
	myChannels: IChannel[];
}

export default function MyChannelList({myChannels}: IProps) {
	const {t} = useTranslation();
	if (myChannels.length) {
		return (
			<>
				<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'primary.900' : 'secondary50'}}
				            className="font-medium pt-4">{t('my_channels')}</Typography>
				<List sx={{
					borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : theme.palette.grey[700],
					bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'background.paper'
				}} className="rounded border py-0">
					{
						myChannels.map((channel, index) => <>
							<MyChannel key={channel.id} channel={channel}/>
							{index < myChannels.length - 1 && <Divider/>}
						</>)
					}
				</List>
			</>
		);
	} else {
		return (
			<>
				<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'primary.900' : 'secondary50'}}
				            className="font-medium pt-4">{t('my_channels')}</Typography>
				<Box sx={{
					borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : theme.palette.grey[700],
					bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'background.paper'
				}} className="h-20 border rounded flex flex-col justify-center items-center space-y-2">
					<Typography sx={{
						color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.200',
						fontSize: (theme) => theme.typography.fontSize - 2
					}} className="font-medium">{t('not_member_of_any_channel')}</Typography>
					<div className="flex flex-row space-x-2 rtl:space-x-reverse">
						<ArrowDownIcon/>
						<Typography sx={{
							color: (theme) => theme.palette.mode === 'light' ? 'grey.700' : 'grey.400',
							fontSize: (theme) => theme.typography.fontSize - 2
						}} className="font-medium">{t('see_channels')}</Typography>
					</div>
				</Box>
			</>
		);
	}
}
